import config from "../../app.json";
import axios from "axios";

import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Row } from "react-bootstrap";
import "react-toggle/style.css";
import FieldText from "../Fields/FieldText";
import FieldSelect from "../Fields/FieldSelect";
import FieldTextarea from "../Fields/FieldTextarea";
import AlertComponent from "../AlertComponent";

function AddOrEditFacebookOutput(props) {
  const { outputName, handleAddNewElementsOutput, currentElement } = props;

  const [destionationPageOptions, setDestionationPageOptions] = useState([]);
  const [facebookPostTitle, setFacebookPostTitle] = useState(null);
  const [facebookPostDescription, setFacebookPostDescription] = useState(null);
  const [facebookAccessToken, setFacebookAccessToken] = useState(null);
  const [selectedDestionationPage, setSelectedDestionationPage] =
    useState(null);

  const handleFacebookLogin = () => {
    try {
      window.FB.login(
        function (response) {
          if (response?.authResponse?.accessToken)
            setFacebookAccessToken(response.authResponse.accessToken);
        },
        {
          config_id: config.FacebookAppConfig,
        }
      );
    } catch (error) {
      return AlertComponent("Error", error.message, {
        icon: `error`,
      });
    }
  };

  const handleFacebookPages = () => {
    axios
      .post(config.API + "/api/facebook/getPagesSelect", {
        accessToken: facebookAccessToken,
      })
      .then((res) => {
        if (res.status === 200) {
          setDestionationPageOptions(res.data.$values);
          if (currentElement) {
            const currentPage = res.data.$values
              .filter((x) => x.value === currentElement.destinationPageId)
              ?.at(0);
            if (currentPage) {
              setSelectedDestionationPage(currentPage);
            }
          }
        } else
          return AlertComponent("Error", res.statusText, { icon: `error` });
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  // Load pages
  useEffect(() => {
    if (facebookAccessToken) {
      handleFacebookPages();
    }
  }, [facebookAccessToken]);

  useEffect(() => {
    if (currentElement) {
      setFacebookPostTitle(currentElement.postTitle);
      setFacebookPostDescription(currentElement.postDescription);
      setFacebookAccessToken(currentElement.facebookAccessToken);
    }
  }, [currentElement]);

  const handleAddItem = () => {
    if (!outputName) {
      return AlertComponent("Error", "Output name is required", {
        icon: `error`,
      });
    }

    if (!facebookAccessToken) {
      return AlertComponent(
        "Error",
        "Facebook login required before proceeding",
        {
          icon: `error`,
        }
      );
    }

    if (!facebookPostTitle) {
      return AlertComponent("Error", "Facebook Post Title is required", {
        icon: `error`,
      });
    }

    if (!facebookPostDescription) {
      return AlertComponent("Error", "Facebook Post Description is required", {
        icon: `error`,
      });
    }

    if (!selectedDestionationPage) {
      return AlertComponent("Error", "Destination page is required", {
        icon: `error`,
      });
    }

    let item = {
      name: outputName,
      outputType: `Facebook`,
      postTitle: facebookPostTitle,
      postDescription: facebookPostDescription,
      destinationPageId: selectedDestionationPage?.value,
      facebookAccessToken: facebookAccessToken,
    };

    if (currentElement) {
      item = { ...currentElement };
      item.name = outputName;
      item.outputType = `Facebook`;
      item.postTitle = facebookPostTitle;
      item.postDescription = facebookPostDescription;
      item.destinationPageId = selectedDestionationPage?.value;
      item.facebookAccessToken = facebookAccessToken;
    }

    handleAddNewElementsOutput(item);
  };

  return (
    <div>
      <FieldText
        label="Facebook Post Title"
        type="text"
        onChange={(x) => setFacebookPostTitle(x.target.value)}
        placeholder="Enter here your Facebook livestream post title. e.g: “Join us for Sunday Service"
        value={facebookPostTitle}
        className="col-md-12"
        required={true}
        inputClassName={`inputOption`}
      />

      <FieldTextarea
        label="Post Description"
        type="text"
        onChange={(x) => setFacebookPostDescription(x.target.value)}
        placeholder="Enter here your Facebook post description. e.g: “Join us for Sunday Service! Live on Facebook at 8 am, 9:30 am, and 11 am eastern time."
        value={facebookPostDescription}
        className="col-md-12"
        required={true}
        inputClassName={`inputOption`}
      />

      <Row>
        <Col md={12} className="d-flex justify-content-start">
          <Button
            className="facebook-btn"
            onClick={handleFacebookLogin}
            disabled={facebookAccessToken != null}
          >
            Login with Facebook
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className="small-info mt-2 mb-4">
            Once you allow the connection with Facebook we will list your
            options to share.
          </div>
        </Col>
      </Row>

      <FieldSelect
        readonly={
          destionationPageOptions == null || destionationPageOptions.length == 0
        }
        label={`Select the destination page`}
        options={destionationPageOptions}
        className={`col-md-12`}
        id={`selectedDestionationPage`}
        name={`selectedDestionationPage`}
        onChange={setSelectedDestionationPage}
        value={selectedDestionationPage}
        placeholder={`Choose the destination page`}
      />

      <Button className="dark-btn" onClick={handleAddItem}>
        {currentElement ? "Edit" : "Add"}
      </Button>
    </div>
  );
}

export default AddOrEditFacebookOutput;
